import * as Yup from 'yup'

export const AddTransferValidationSchema = Yup.object().shape({
	bin: Yup.string().required({ key: 'required' }).nullable(),
	branchNameKz: Yup.string().nullable(),
	branchNameRu: Yup.string().nullable(),
	contracts: Yup.object().nullable(),
})
